/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';


@Injectable({
  providedIn: 'root',
})
export class NlsQuerySchemaConfigurationService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getNlsQuerySchemaBlueprint
   */
  static readonly GetNlsQuerySchemaBlueprintPath = '/nls/schema-blueprint';

  /**
   * GET Tenant specific NLS Query Schema Blueprint.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getNlsQuerySchemaBlueprint()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNlsQuerySchemaBlueprint$Response(params: {

    /**
     * The tenant code
     */
    'x-tenant-id': string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, NlsQuerySchemaConfigurationService.GetNlsQuerySchemaBlueprintPath, 'get');
    if (params) {
      rb.header('x-tenant-id', params['x-tenant-id'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json; charset&#x3D;utf-8',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * GET Tenant specific NLS Query Schema Blueprint.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getNlsQuerySchemaBlueprint$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNlsQuerySchemaBlueprint(params: {

    /**
     * The tenant code
     */
    'x-tenant-id': string;
  },
  context?: HttpContext

): Observable<string> {

    return this.getNlsQuerySchemaBlueprint$Response(params,context).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

}
